import React from 'react';
import styled from 'styled-components';

const OrderSummary = styled.div`
  margin-bottom: 20px;

  // This allows custom text to be inserted via the theme
  ::after {
    ${props => props.theme?.orderSummary?.subText};
  }
`;

const Label = styled.p`
  color: ${props => props.theme?.orderSummary?.labelColor};
  font-size: ${props => props.theme?.orderSummary?.labelFontSize};
  font-weight: ${props => props.theme?.orderSummary?.labelFontWeight};
  margin-bottom: 0;
`;

const OrderText = styled.div`
  color: ${props => props.theme?.orderSummary?.color};
  font-size: ${props => props.theme?.orderSummary?.fontSize};
`;

export default function OrderSummaryText({orderText}) {
  return (
    <OrderSummary>
      <Label>Je bestelling:</Label>
      <OrderText>{orderText}</OrderText>
    </OrderSummary>
  );
}
